(() => {
  if (window.__theOneDesktopLocalizationReady) return;
  window.__theOneDesktopLocalizationReady = true;

  const selector = '.the-one-desktop-localization details[open]';

  const closeDetails = (details) => {
    if (!details || !details.open) return;
    details.open = false;
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll(selector).forEach((details) => {
      if (!details.contains(event.target)) closeDetails(details);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openDetails = document.querySelector(selector);
    if (!openDetails) return;

    const summary = openDetails.querySelector('summary');
    closeDetails(openDetails);
    summary?.focus();
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;

      if (
        !(details instanceof HTMLDetailsElement) ||
        !details.matches('.the-one-desktop-localization details') ||
        !details.open
      ) {
        return;
      }

      const group = details.closest('.the-one-desktop-localization');
      group?.querySelectorAll('details[open]').forEach((item) => {
        if (item !== details) closeDetails(item);
      });
    },
    true
  );
})();